import { FC } from 'react';

import TourAutoComplate, { TourTypes } from '@domain/tour/tourAutoComplate';
import useSearchBar from '@contexts/searchbar';
import { TourSearchBarActionType } from '@contexts/searchbar/types/tour';
import { useBreakpoint } from '@contexts/breakpoints';

import { Wrapper } from './styled';
import MobileTourSelection from './MobileTourSelection';

type PropTypes = {
  onChange?: (data: TourTypes) => void;
  isSubmit: boolean;
  resetIsSubmit: () => void;
  pastTourItems?: TourTypes[];
  clearPastTourSearch?: () => void;
  removePastTourSearch?: (item: TourTypes) => void;
  onInputClear?: () => void;
};

const TourSelection: FC<PropTypes> = ({
  onChange: pOnChange = (v) => v,
  isSubmit,
  resetIsSubmit,
  pastTourItems,
  clearPastTourSearch,
  removePastTourSearch,
}) => {
  const { xl: isDesktop } = useBreakpoint();
  const {
    state: { tour: state },
    dispatch,
  } = useSearchBar();

  const handleOnChange = (selectedTour: TourTypes) => {
    if (selectedTour) {
      pOnChange(selectedTour);
    }
  };

  return (
    <Wrapper>
      {isDesktop ? (
        <TourAutoComplate
          label='Şehir, Bölge ya da Tur Adı Giriniz'
          onChange={handleOnChange}
          editable={isDesktop}
          isSubmit={isSubmit}
          resetIsSubmit={resetIsSubmit}
          value={state.searchData}
          pastTourItems={pastTourItems}
          clearPastTourSearch={clearPastTourSearch}
          removePastTourSearch={removePastTourSearch}
        />
      ) : (
        <MobileTourSelection
          label='Şehir, Bölge ya da Tur Adı Giriniz?'
          onChange={handleOnChange}
          data-test='tour-autocomplete'
          history={pastTourItems}
          clearPastTourSearch={clearPastTourSearch}
          removePastTourSearch={removePastTourSearch}
          activeLocation={state.searchData}
          isLocationError={state.isSearchDataError}
          setIsLocationError={(value) =>
            dispatch({
              type: TourSearchBarActionType.SET_IS_SEARCH_DATA_ERROR,
              payload: value,
            })
          }
        />
      )}
    </Wrapper>
  );
};
export default TourSelection;
